module.exports = __webpack_public_path__ + "static/IMG_7881-60b8a37874916e4e54736c69f45dfb03.jpg";